import { useMemo } from 'react';
import { useLocation } from 'react-router';

export const useContentPreviewScreenLogic = () => {
  const location = useLocation();

  const urlSearchParams = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location]);

  const contentType = urlSearchParams.get('type');
  const contentUrl = urlSearchParams.get('url');

  return {
    contentType,
    contentUrl,
  };
};
